import React from 'react';

const OrganizationSettings = () => {
  return (
    <div>
     <h2 style={{ fontSize: "22px", fontWeight: "500", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
     How organization settings affect timesheets?
            </h2>
      <p>
        From the main dashboard, navigate to Organization Settings to configure your organization's product access.
      </p>

      <h5>Configure Product Access</h5>
      <p>
        In the Product Access section, you can enable or disable access to different products for your organization:
      </p>
      <ul>
        <li>
          <strong>SAT:</strong> Enable or disable access to the SAT product by clicking the corresponding checkbox.
        </li>
        <li>
          <strong>TIME SHEET:</strong> Enable or disable access to the Time Sheet product by clicking the corresponding checkbox.
        </li>
        <li>
          <strong>JOB PORTAL:</strong> Enable or disable access to the Job Portal product by clicking the corresponding checkbox.
        </li>
      </ul>

      <img
                className="placeholder-image image_gatnix_support"
                src="  https://res.cloudinary.com/danfpnuui/image/upload/v1740683808/WhatsApp_Image_2025-02-26_at_9.37.24_PM_7_z88brr.jpg"
                alt="Employee Table Screenshot"
            />
    </div>
  );
};

export default OrganizationSettings;
